import styled from "styled-components";
import { rem } from "../Theme/Theme.constants.js";
import { ITheme } from "../Theme/Theme.types.js";
import { AvatarProps, DefaultAvatarProps } from "./Avatar.types.js";

const getShapeMap = ({ theme }: { theme: ITheme }): Record<DefaultAvatarProps["shape"], string> => ({
    squared: theme.radius.s,
    rounded: theme.radius.round,
});

export const sizeMap: Record<DefaultAvatarProps["size"], string> = {
    medium: rem(3),
    small: rem(1.825),
    extraSmall: rem(1.5),
    large: rem(4),
    extraLarge: rem(6),
};

export const StyledAvatar = styled.img<Pick<{ mask: boolean } & AvatarProps & DefaultAvatarProps, "shape" | "size">>`
    border-radius: ${({ shape, theme }) => getShapeMap({ theme })[shape]};
    height: 100%;
    width: 100%;
    object-position: center;
    object-fit: cover;
`;

export const AvatarContainer = styled.div<AvatarProps & DefaultAvatarProps>`
    border-radius: ${({ shape, theme }) => getShapeMap({ theme })[shape]};
    width: ${({ size }) => sizeMap[size]};
    height: ${({ size }) => sizeMap[size]};
    position: relative;
    ${({ border, theme }) =>
        border &&
        `
    outline: 2px solid ${theme.grayscale.white};
`}
`;

export const AvatarsContainer = styled.div`
    margin: auto;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.rem(1)};
`;
